import React from 'react';

const StockInOutCard = () => {
    return (
        <div className="card h-full ">
            <div className="flex align-items-center justify-content-between h-full px-3">
                {/* Left: Stock In */}
                <div className="flex flex-column align-items-start gap-2">
                    <span className="text-900 text-lg font-semibold">Stock In</span>
                    <div className="flex align-items-center gap-3">
                        <span className="text-4xl font-bold text-900">320</span>
                        <div className="flex flex-column align-items-center">
                            <i className="pi pi-arrow-down text-green-500" style={{ fontSize: '1.25rem' }} aria-hidden="true"></i>
                            <small className="text-green-500">+12%</small>
                        </div>
                    </div>
                    <small className="text-500">Last 24h</small>
                </div>

                {/* Divider (optional) */}
                <div style={{ width: 1, height: '60%', background: 'var(--surface-border)' }} aria-hidden="true"></div>

                {/* Right: Stock Out */}
                <div className="flex flex-column align-items-end gap-2">
                    <span className="text-900 text-lg font-semibold">Stock Out</span>
                    <div className="flex align-items-center gap-3">
                        <div className="flex flex-column align-items-center">
                            <i className="pi pi-arrow-up text-red-500" style={{ fontSize: '1.25rem' }} aria-hidden="true"></i>
                            <small className="text-red-500">-8%</small>
                        </div>
                        <span className="text-4xl font-bold text-900">120</span>
                    </div>
                    <small className="text-500">Last 24h</small>
                </div>
            </div>
        </div>
    );
};

export default StockInOutCard;